import style from "./Hero.module.css";

export default function Hero({image, headline, text} : {image:string, headline?:string, text?:string}) {
  return (
<section className={style.hero}>
  <img
    src= {image} //Todo: richtige Auflösung
    alt=""
    className={style.hero__bg}
    aria-hidden="true"
  />

  <div className={style.hero__overlay} aria-hidden="true" />

  <div className={style.hero__content}>
    {headline && <h1 className={style.hero__title}>{headline}</h1>}
    {text && <p className={style.hero__subtitle}>{text}</p>}
  </div>

</section>
  );
}